import './App.css';
import { BrowserRouter } from "react-router-dom"
import AppRoute from './routes';
import { useSelector } from 'react-redux';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer } from 'react-notifications';
import SideNav from './components/arbor/sidenav';


function App() {
  const { isLoggedIn } = useSelector(({arboristLogin})=>arboristLogin)
  return (
     <>        
    <BrowserRouter>                   
      {isLoggedIn ? <SideNav /> : <AppRoute />}          
      <NotificationContainer />             
      </BrowserRouter>                                         
</>
  );
}

export default App;
